/**
 * TB-App API – Generated by orval 🍺
 * Do not edit manually.
 */
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';
import { useMutation, useQuery, useSuspenseQuery } from '@tanstack/react-query';
import type { BodyType, ErrorType } from '../../axios';
import { request } from '../../axios';
import type {
  CreateQuantiferonTestDto,
  CreateSputumTestDto,
  CreateTspotTestDto,
  CreateTuberculinTestDto,
  CreateXrayTestDto,
  LabOrderDto,
} from '.././model';

type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];

export const updateXrayTest = (
  id: string,
  createXrayTestDto: BodyType<CreateXrayTestDto>,
  options?: SecondParameter<typeof request>,
) => {
  return request<void>(
    {
      url: `/api/diagnosis/lab-orders/${id}/xray`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: createXrayTestDto,
    },
    options,
  );
};

export const getUpdateXrayTestMutationOptions = <
  TData = Awaited<ReturnType<typeof updateXrayTest>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { id: string; data: BodyType<CreateXrayTestDto> }, TContext>;
  request?: SecondParameter<typeof request>;
}) => {
  const mutationKey = ['updateXrayTest'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateXrayTest>>,
    { id: string; data: BodyType<CreateXrayTestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateXrayTest(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { id: string; data: BodyType<CreateXrayTestDto> },
    TContext
  >;
};

export type UpdateXrayTestMutationResult = NonNullable<Awaited<ReturnType<typeof updateXrayTest>>>;
export type UpdateXrayTestMutationBody = BodyType<CreateXrayTestDto>;
export type UpdateXrayTestMutationError = ErrorType<unknown>;

export const useUpdateXrayTest = <
  TData = Awaited<ReturnType<typeof updateXrayTest>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { id: string; data: BodyType<CreateXrayTestDto> }, TContext>;
  request?: SecondParameter<typeof request>;
}): UseMutationResult<TData, TError, { id: string; data: BodyType<CreateXrayTestDto> }, TContext> => {
  const mutationOptions = getUpdateXrayTestMutationOptions(options);

  return useMutation(mutationOptions);
};
export const updateTuberculinTest = (
  id: string,
  createTuberculinTestDto: BodyType<CreateTuberculinTestDto>,
  options?: SecondParameter<typeof request>,
) => {
  return request<void>(
    {
      url: `/api/diagnosis/lab-orders/${id}/tuberculin`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: createTuberculinTestDto,
    },
    options,
  );
};

export const getUpdateTuberculinTestMutationOptions = <
  TData = Awaited<ReturnType<typeof updateTuberculinTest>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { id: string; data: BodyType<CreateTuberculinTestDto> }, TContext>;
  request?: SecondParameter<typeof request>;
}) => {
  const mutationKey = ['updateTuberculinTest'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateTuberculinTest>>,
    { id: string; data: BodyType<CreateTuberculinTestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateTuberculinTest(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { id: string; data: BodyType<CreateTuberculinTestDto> },
    TContext
  >;
};

export type UpdateTuberculinTestMutationResult = NonNullable<Awaited<ReturnType<typeof updateTuberculinTest>>>;
export type UpdateTuberculinTestMutationBody = BodyType<CreateTuberculinTestDto>;
export type UpdateTuberculinTestMutationError = ErrorType<unknown>;

export const useUpdateTuberculinTest = <
  TData = Awaited<ReturnType<typeof updateTuberculinTest>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { id: string; data: BodyType<CreateTuberculinTestDto> }, TContext>;
  request?: SecondParameter<typeof request>;
}): UseMutationResult<TData, TError, { id: string; data: BodyType<CreateTuberculinTestDto> }, TContext> => {
  const mutationOptions = getUpdateTuberculinTestMutationOptions(options);

  return useMutation(mutationOptions);
};
export const updateTSpotTest = (
  id: string,
  createTspotTestDto: BodyType<CreateTspotTestDto>,
  options?: SecondParameter<typeof request>,
) => {
  return request<void>(
    {
      url: `/api/diagnosis/lab-orders/${id}/tspot`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: createTspotTestDto,
    },
    options,
  );
};

export const getUpdateTSpotTestMutationOptions = <
  TData = Awaited<ReturnType<typeof updateTSpotTest>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { id: string; data: BodyType<CreateTspotTestDto> }, TContext>;
  request?: SecondParameter<typeof request>;
}) => {
  const mutationKey = ['updateTSpotTest'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateTSpotTest>>,
    { id: string; data: BodyType<CreateTspotTestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateTSpotTest(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { id: string; data: BodyType<CreateTspotTestDto> },
    TContext
  >;
};

export type UpdateTSpotTestMutationResult = NonNullable<Awaited<ReturnType<typeof updateTSpotTest>>>;
export type UpdateTSpotTestMutationBody = BodyType<CreateTspotTestDto>;
export type UpdateTSpotTestMutationError = ErrorType<unknown>;

export const useUpdateTSpotTest = <
  TData = Awaited<ReturnType<typeof updateTSpotTest>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { id: string; data: BodyType<CreateTspotTestDto> }, TContext>;
  request?: SecondParameter<typeof request>;
}): UseMutationResult<TData, TError, { id: string; data: BodyType<CreateTspotTestDto> }, TContext> => {
  const mutationOptions = getUpdateTSpotTestMutationOptions(options);

  return useMutation(mutationOptions);
};
export const updateSputumTest = (
  id: string,
  createSputumTestDto: BodyType<CreateSputumTestDto>,
  options?: SecondParameter<typeof request>,
) => {
  return request<void>(
    {
      url: `/api/diagnosis/lab-orders/${id}/sputum`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: createSputumTestDto,
    },
    options,
  );
};

export const getUpdateSputumTestMutationOptions = <
  TData = Awaited<ReturnType<typeof updateSputumTest>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { id: string; data: BodyType<CreateSputumTestDto> }, TContext>;
  request?: SecondParameter<typeof request>;
}) => {
  const mutationKey = ['updateSputumTest'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateSputumTest>>,
    { id: string; data: BodyType<CreateSputumTestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateSputumTest(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { id: string; data: BodyType<CreateSputumTestDto> },
    TContext
  >;
};

export type UpdateSputumTestMutationResult = NonNullable<Awaited<ReturnType<typeof updateSputumTest>>>;
export type UpdateSputumTestMutationBody = BodyType<CreateSputumTestDto>;
export type UpdateSputumTestMutationError = ErrorType<unknown>;

export const useUpdateSputumTest = <
  TData = Awaited<ReturnType<typeof updateSputumTest>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { id: string; data: BodyType<CreateSputumTestDto> }, TContext>;
  request?: SecondParameter<typeof request>;
}): UseMutationResult<TData, TError, { id: string; data: BodyType<CreateSputumTestDto> }, TContext> => {
  const mutationOptions = getUpdateSputumTestMutationOptions(options);

  return useMutation(mutationOptions);
};
export const updateQuantiferonTest = (
  id: string,
  createQuantiferonTestDto: BodyType<CreateQuantiferonTestDto>,
  options?: SecondParameter<typeof request>,
) => {
  return request<void>(
    {
      url: `/api/diagnosis/lab-orders/${id}/quantiferon`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: createQuantiferonTestDto,
    },
    options,
  );
};

export const getUpdateQuantiferonTestMutationOptions = <
  TData = Awaited<ReturnType<typeof updateQuantiferonTest>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { id: string; data: BodyType<CreateQuantiferonTestDto> }, TContext>;
  request?: SecondParameter<typeof request>;
}) => {
  const mutationKey = ['updateQuantiferonTest'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateQuantiferonTest>>,
    { id: string; data: BodyType<CreateQuantiferonTestDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateQuantiferonTest(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { id: string; data: BodyType<CreateQuantiferonTestDto> },
    TContext
  >;
};

export type UpdateQuantiferonTestMutationResult = NonNullable<Awaited<ReturnType<typeof updateQuantiferonTest>>>;
export type UpdateQuantiferonTestMutationBody = BodyType<CreateQuantiferonTestDto>;
export type UpdateQuantiferonTestMutationError = ErrorType<unknown>;

export const useUpdateQuantiferonTest = <
  TData = Awaited<ReturnType<typeof updateQuantiferonTest>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { id: string; data: BodyType<CreateQuantiferonTestDto> }, TContext>;
  request?: SecondParameter<typeof request>;
}): UseMutationResult<TData, TError, { id: string; data: BodyType<CreateQuantiferonTestDto> }, TContext> => {
  const mutationOptions = getUpdateQuantiferonTestMutationOptions(options);

  return useMutation(mutationOptions);
};
export const createXrayTest = (
  createXrayTestDto: BodyType<CreateXrayTestDto>,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<string>(
    {
      url: `/api/diagnosis/lab-orders/xray`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createXrayTestDto,
      signal,
    },
    options,
  );
};

export const getCreateXrayTestMutationOptions = <
  TData = Awaited<ReturnType<typeof createXrayTest>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { data: BodyType<CreateXrayTestDto> }, TContext>;
  request?: SecondParameter<typeof request>;
}) => {
  const mutationKey = ['createXrayTest'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createXrayTest>>,
    { data: BodyType<CreateXrayTestDto> }
  > = (props) => {
    const { data } = props ?? {};

    return createXrayTest(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { data: BodyType<CreateXrayTestDto> },
    TContext
  >;
};

export type CreateXrayTestMutationResult = NonNullable<Awaited<ReturnType<typeof createXrayTest>>>;
export type CreateXrayTestMutationBody = BodyType<CreateXrayTestDto>;
export type CreateXrayTestMutationError = ErrorType<unknown>;

export const useCreateXrayTest = <
  TData = Awaited<ReturnType<typeof createXrayTest>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { data: BodyType<CreateXrayTestDto> }, TContext>;
  request?: SecondParameter<typeof request>;
}): UseMutationResult<TData, TError, { data: BodyType<CreateXrayTestDto> }, TContext> => {
  const mutationOptions = getCreateXrayTestMutationOptions(options);

  return useMutation(mutationOptions);
};
export const createTuberculinTest = (
  createTuberculinTestDto: BodyType<CreateTuberculinTestDto>,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<string>(
    {
      url: `/api/diagnosis/lab-orders/tuberculin`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createTuberculinTestDto,
      signal,
    },
    options,
  );
};

export const getCreateTuberculinTestMutationOptions = <
  TData = Awaited<ReturnType<typeof createTuberculinTest>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { data: BodyType<CreateTuberculinTestDto> }, TContext>;
  request?: SecondParameter<typeof request>;
}) => {
  const mutationKey = ['createTuberculinTest'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createTuberculinTest>>,
    { data: BodyType<CreateTuberculinTestDto> }
  > = (props) => {
    const { data } = props ?? {};

    return createTuberculinTest(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { data: BodyType<CreateTuberculinTestDto> },
    TContext
  >;
};

export type CreateTuberculinTestMutationResult = NonNullable<Awaited<ReturnType<typeof createTuberculinTest>>>;
export type CreateTuberculinTestMutationBody = BodyType<CreateTuberculinTestDto>;
export type CreateTuberculinTestMutationError = ErrorType<unknown>;

export const useCreateTuberculinTest = <
  TData = Awaited<ReturnType<typeof createTuberculinTest>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { data: BodyType<CreateTuberculinTestDto> }, TContext>;
  request?: SecondParameter<typeof request>;
}): UseMutationResult<TData, TError, { data: BodyType<CreateTuberculinTestDto> }, TContext> => {
  const mutationOptions = getCreateTuberculinTestMutationOptions(options);

  return useMutation(mutationOptions);
};
export const createTspotTest = (
  createTspotTestDto: BodyType<CreateTspotTestDto>,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<string>(
    {
      url: `/api/diagnosis/lab-orders/tspot`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createTspotTestDto,
      signal,
    },
    options,
  );
};

export const getCreateTspotTestMutationOptions = <
  TData = Awaited<ReturnType<typeof createTspotTest>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { data: BodyType<CreateTspotTestDto> }, TContext>;
  request?: SecondParameter<typeof request>;
}) => {
  const mutationKey = ['createTspotTest'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createTspotTest>>,
    { data: BodyType<CreateTspotTestDto> }
  > = (props) => {
    const { data } = props ?? {};

    return createTspotTest(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { data: BodyType<CreateTspotTestDto> },
    TContext
  >;
};

export type CreateTspotTestMutationResult = NonNullable<Awaited<ReturnType<typeof createTspotTest>>>;
export type CreateTspotTestMutationBody = BodyType<CreateTspotTestDto>;
export type CreateTspotTestMutationError = ErrorType<unknown>;

export const useCreateTspotTest = <
  TData = Awaited<ReturnType<typeof createTspotTest>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { data: BodyType<CreateTspotTestDto> }, TContext>;
  request?: SecondParameter<typeof request>;
}): UseMutationResult<TData, TError, { data: BodyType<CreateTspotTestDto> }, TContext> => {
  const mutationOptions = getCreateTspotTestMutationOptions(options);

  return useMutation(mutationOptions);
};
export const createSputumTest = (
  createSputumTestDto: BodyType<CreateSputumTestDto>,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<string>(
    {
      url: `/api/diagnosis/lab-orders/sputum`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createSputumTestDto,
      signal,
    },
    options,
  );
};

export const getCreateSputumTestMutationOptions = <
  TData = Awaited<ReturnType<typeof createSputumTest>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { data: BodyType<CreateSputumTestDto> }, TContext>;
  request?: SecondParameter<typeof request>;
}) => {
  const mutationKey = ['createSputumTest'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createSputumTest>>,
    { data: BodyType<CreateSputumTestDto> }
  > = (props) => {
    const { data } = props ?? {};

    return createSputumTest(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { data: BodyType<CreateSputumTestDto> },
    TContext
  >;
};

export type CreateSputumTestMutationResult = NonNullable<Awaited<ReturnType<typeof createSputumTest>>>;
export type CreateSputumTestMutationBody = BodyType<CreateSputumTestDto>;
export type CreateSputumTestMutationError = ErrorType<unknown>;

export const useCreateSputumTest = <
  TData = Awaited<ReturnType<typeof createSputumTest>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { data: BodyType<CreateSputumTestDto> }, TContext>;
  request?: SecondParameter<typeof request>;
}): UseMutationResult<TData, TError, { data: BodyType<CreateSputumTestDto> }, TContext> => {
  const mutationOptions = getCreateSputumTestMutationOptions(options);

  return useMutation(mutationOptions);
};
export const createQuantiferonTest = (
  createQuantiferonTestDto: BodyType<CreateQuantiferonTestDto>,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<string>(
    {
      url: `/api/diagnosis/lab-orders/quantiferon`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createQuantiferonTestDto,
      signal,
    },
    options,
  );
};

export const getCreateQuantiferonTestMutationOptions = <
  TData = Awaited<ReturnType<typeof createQuantiferonTest>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { data: BodyType<CreateQuantiferonTestDto> }, TContext>;
  request?: SecondParameter<typeof request>;
}) => {
  const mutationKey = ['createQuantiferonTest'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createQuantiferonTest>>,
    { data: BodyType<CreateQuantiferonTestDto> }
  > = (props) => {
    const { data } = props ?? {};

    return createQuantiferonTest(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { data: BodyType<CreateQuantiferonTestDto> },
    TContext
  >;
};

export type CreateQuantiferonTestMutationResult = NonNullable<Awaited<ReturnType<typeof createQuantiferonTest>>>;
export type CreateQuantiferonTestMutationBody = BodyType<CreateQuantiferonTestDto>;
export type CreateQuantiferonTestMutationError = ErrorType<unknown>;

export const useCreateQuantiferonTest = <
  TData = Awaited<ReturnType<typeof createQuantiferonTest>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { data: BodyType<CreateQuantiferonTestDto> }, TContext>;
  request?: SecondParameter<typeof request>;
}): UseMutationResult<TData, TError, { data: BodyType<CreateQuantiferonTestDto> }, TContext> => {
  const mutationOptions = getCreateQuantiferonTestMutationOptions(options);

  return useMutation(mutationOptions);
};
export const getLabOrdersByPatient = (
  patientId: string,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<LabOrderDto[]>(
    { url: `/api/diagnosis/lab-orders/patient/${patientId}`, method: 'GET', signal },
    options,
  );
};

export const getGetLabOrdersByPatientQueryKey = (patientId: string) => {
  return [`/api/diagnosis/lab-orders/patient/${patientId}`] as const;
};

export const getGetLabOrdersByPatientQueryOptions = <
  TData = Awaited<ReturnType<typeof getLabOrdersByPatient>>,
  TError = ErrorType<unknown>,
>(
  patientId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getLabOrdersByPatient>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetLabOrdersByPatientQueryKey(patientId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getLabOrdersByPatient>>> = ({ signal }) =>
    getLabOrdersByPatient(patientId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!patientId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getLabOrdersByPatient>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetLabOrdersByPatientQueryResult = NonNullable<Awaited<ReturnType<typeof getLabOrdersByPatient>>>;
export type GetLabOrdersByPatientQueryError = ErrorType<unknown>;

export function useGetLabOrdersByPatient<
  TData = Awaited<ReturnType<typeof getLabOrdersByPatient>>,
  TError = ErrorType<unknown>,
>(
  patientId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getLabOrdersByPatient>>, TError, TData>> &
      Pick<DefinedInitialDataOptions<Awaited<ReturnType<typeof getLabOrdersByPatient>>, TError, TData>, 'initialData'>;
    request?: SecondParameter<typeof request>;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetLabOrdersByPatient<
  TData = Awaited<ReturnType<typeof getLabOrdersByPatient>>,
  TError = ErrorType<unknown>,
>(
  patientId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getLabOrdersByPatient>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof getLabOrdersByPatient>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof request>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetLabOrdersByPatient<
  TData = Awaited<ReturnType<typeof getLabOrdersByPatient>>,
  TError = ErrorType<unknown>,
>(
  patientId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getLabOrdersByPatient>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetLabOrdersByPatient<
  TData = Awaited<ReturnType<typeof getLabOrdersByPatient>>,
  TError = ErrorType<unknown>,
>(
  patientId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getLabOrdersByPatient>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetLabOrdersByPatientQueryOptions(patientId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetLabOrdersByPatientSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getLabOrdersByPatient>>,
  TError = ErrorType<unknown>,
>(
  patientId: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getLabOrdersByPatient>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetLabOrdersByPatientQueryKey(patientId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getLabOrdersByPatient>>> = ({ signal }) =>
    getLabOrdersByPatient(patientId, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getLabOrdersByPatient>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetLabOrdersByPatientSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getLabOrdersByPatient>>>;
export type GetLabOrdersByPatientSuspenseQueryError = ErrorType<unknown>;

export function useGetLabOrdersByPatientSuspense<
  TData = Awaited<ReturnType<typeof getLabOrdersByPatient>>,
  TError = ErrorType<unknown>,
>(
  patientId: string,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getLabOrdersByPatient>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetLabOrdersByPatientSuspense<
  TData = Awaited<ReturnType<typeof getLabOrdersByPatient>>,
  TError = ErrorType<unknown>,
>(
  patientId: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getLabOrdersByPatient>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetLabOrdersByPatientSuspense<
  TData = Awaited<ReturnType<typeof getLabOrdersByPatient>>,
  TError = ErrorType<unknown>,
>(
  patientId: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getLabOrdersByPatient>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetLabOrdersByPatientSuspense<
  TData = Awaited<ReturnType<typeof getLabOrdersByPatient>>,
  TError = ErrorType<unknown>,
>(
  patientId: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getLabOrdersByPatient>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetLabOrdersByPatientSuspenseQueryOptions(patientId, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getLabOrderByAppointmentId = (
  appointmentId: string,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<LabOrderDto>(
    { url: `/api/diagnosis/lab-orders/appointment/${appointmentId}`, method: 'GET', signal },
    options,
  );
};

export const getGetLabOrderByAppointmentIdQueryKey = (appointmentId: string) => {
  return [`/api/diagnosis/lab-orders/appointment/${appointmentId}`] as const;
};

export const getGetLabOrderByAppointmentIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getLabOrderByAppointmentId>>,
  TError = ErrorType<unknown>,
>(
  appointmentId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getLabOrderByAppointmentId>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetLabOrderByAppointmentIdQueryKey(appointmentId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getLabOrderByAppointmentId>>> = ({ signal }) =>
    getLabOrderByAppointmentId(appointmentId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!appointmentId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getLabOrderByAppointmentId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetLabOrderByAppointmentIdQueryResult = NonNullable<Awaited<ReturnType<typeof getLabOrderByAppointmentId>>>;
export type GetLabOrderByAppointmentIdQueryError = ErrorType<unknown>;

export function useGetLabOrderByAppointmentId<
  TData = Awaited<ReturnType<typeof getLabOrderByAppointmentId>>,
  TError = ErrorType<unknown>,
>(
  appointmentId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getLabOrderByAppointmentId>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof getLabOrderByAppointmentId>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof request>;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetLabOrderByAppointmentId<
  TData = Awaited<ReturnType<typeof getLabOrderByAppointmentId>>,
  TError = ErrorType<unknown>,
>(
  appointmentId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getLabOrderByAppointmentId>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof getLabOrderByAppointmentId>>, TError, TData>,
        'initialData'
      >;
    request?: SecondParameter<typeof request>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetLabOrderByAppointmentId<
  TData = Awaited<ReturnType<typeof getLabOrderByAppointmentId>>,
  TError = ErrorType<unknown>,
>(
  appointmentId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getLabOrderByAppointmentId>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetLabOrderByAppointmentId<
  TData = Awaited<ReturnType<typeof getLabOrderByAppointmentId>>,
  TError = ErrorType<unknown>,
>(
  appointmentId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getLabOrderByAppointmentId>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetLabOrderByAppointmentIdQueryOptions(appointmentId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetLabOrderByAppointmentIdSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getLabOrderByAppointmentId>>,
  TError = ErrorType<unknown>,
>(
  appointmentId: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getLabOrderByAppointmentId>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetLabOrderByAppointmentIdQueryKey(appointmentId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getLabOrderByAppointmentId>>> = ({ signal }) =>
    getLabOrderByAppointmentId(appointmentId, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getLabOrderByAppointmentId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetLabOrderByAppointmentIdSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getLabOrderByAppointmentId>>
>;
export type GetLabOrderByAppointmentIdSuspenseQueryError = ErrorType<unknown>;

export function useGetLabOrderByAppointmentIdSuspense<
  TData = Awaited<ReturnType<typeof getLabOrderByAppointmentId>>,
  TError = ErrorType<unknown>,
>(
  appointmentId: string,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getLabOrderByAppointmentId>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetLabOrderByAppointmentIdSuspense<
  TData = Awaited<ReturnType<typeof getLabOrderByAppointmentId>>,
  TError = ErrorType<unknown>,
>(
  appointmentId: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getLabOrderByAppointmentId>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetLabOrderByAppointmentIdSuspense<
  TData = Awaited<ReturnType<typeof getLabOrderByAppointmentId>>,
  TError = ErrorType<unknown>,
>(
  appointmentId: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getLabOrderByAppointmentId>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetLabOrderByAppointmentIdSuspense<
  TData = Awaited<ReturnType<typeof getLabOrderByAppointmentId>>,
  TError = ErrorType<unknown>,
>(
  appointmentId: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getLabOrderByAppointmentId>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetLabOrderByAppointmentIdSuspenseQueryOptions(appointmentId, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const deleteLabOrderById = (id: string, options?: SecondParameter<typeof request>) => {
  return request<void>({ url: `/api/diagnosis/lab-orders/${id}`, method: 'DELETE' }, options);
};

export const getDeleteLabOrderByIdMutationOptions = <
  TData = Awaited<ReturnType<typeof deleteLabOrderById>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { id: string }, TContext>;
  request?: SecondParameter<typeof request>;
}) => {
  const mutationKey = ['deleteLabOrderById'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteLabOrderById>>, { id: string }> = (props) => {
    const { id } = props ?? {};

    return deleteLabOrderById(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<TData, TError, { id: string }, TContext>;
};

export type DeleteLabOrderByIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteLabOrderById>>>;

export type DeleteLabOrderByIdMutationError = ErrorType<unknown>;

export const useDeleteLabOrderById = <
  TData = Awaited<ReturnType<typeof deleteLabOrderById>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { id: string }, TContext>;
  request?: SecondParameter<typeof request>;
}): UseMutationResult<TData, TError, { id: string }, TContext> => {
  const mutationOptions = getDeleteLabOrderByIdMutationOptions(options);

  return useMutation(mutationOptions);
};
